import { type IRowNode } from 'ag-grid-community';

/**
 * Checks if a row node is a duplicate group row, i.e. a child group whose value matches its parent's.
 * When hideDuplicateGroups is enabled these rows are hidden on-screen (Grid.tsx getRowHeight returns 0)
 * and skipped from exports, so the exported file matches the display.
 */
export const isDuplicateGroupRow = (node: IRowNode): boolean =>
  node.parent !== null && node.level > 0 && node.key === node.parent.key;
